import { type PollContentObjectDetail, type UploadedFile, createPollContentObjectDetail } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import type { PollSubmitData } from 'features/polls';
import { createPoll } from '../../services';
import { useContentObjectCache } from '../cache';

type CreatePollData = {
  attachments?: UploadedFile[];
  communityId?: string;
  htmlContent: string;
  pinned?: boolean;
  poll: PollSubmitData;
  textContent: string;
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. Please, try again.');
};

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useCreatePollMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PollContentObjectDetail, CreatePollData>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ attachments, communityId, htmlContent, pinned, poll, textContent }) {
      const response = await createPoll({
        body: {
          poll: {
            ...poll,
            attachments,
            community_id: communityId,
            description: textContent,
            html_description: htmlContent,
            pinned,
          },
        },
      });

      return createPollContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
